import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ICreateProjectParams {
  name: string;
  description?: string;
  parentProjectId?: string;
}

export interface IProjectIdResult extends IResult {
  id: string;
}

export class CreateProjectRequest extends Request<ICreateProjectParams, IProjectIdResult> {
  constructor(params: ICreateProjectParams) {
    super('createProject', params);
  }
}
